import React from 'react';
export function Wildflower({
  className,
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return <svg viewBox="0 0 100 100" className={className} style={style} fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-60">
      <path d="M50 50C50 20 40 5 50 5C60 5 50 20 50 50Z" opacity="0.8" data-id="element-61" />
      <path d="M50 50C80 50 95 40 95 50C95 60 80 50 50 50Z" opacity="0.8" data-id="element-62" />
      <path d="M50 50C50 80 60 95 50 95C40 95 50 80 50 50Z" opacity="0.8" data-id="element-63" />
      <path d="M50 50C20 50 5 60 5 50C5 40 20 50 50 50Z" opacity="0.8" data-id="element-64" />
      <path d="M50 50C70 30 85 15 85 25C85 35 70 50 50 50Z" opacity="0.6" data-id="element-65" />
      <path d="M50 50C70 70 85 85 75 85C65 85 50 70 50 50Z" opacity="0.6" data-id="element-66" />
      <path d="M50 50C30 70 15 85 15 75C15 65 30 50 50 50Z" opacity="0.6" data-id="element-67" />
      <path d="M50 50C30 30 15 15 25 15C35 15 50 30 50 50Z" opacity="0.6" data-id="element-68" />
      <circle cx="50" cy="50" r="8" fill="#D4A24C" data-id="element-69" />
    </svg>;
}